export default {"src":"/_next/static/media/chevron-down.538ce12b.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};